import account from '../account';
import accountSetting from '../passport/accountSetting';
import findPassword from '../passport/findPassword';
import languages from '../languages';
import passport from '../passport';
import support from '../support';
import services from '../services';
import Api from '../../utiles/twStore/js/common/api.js';
import { getJSON, post, STORE_HOST } from '../ultile';
import dialog, { SHOW_TIPS_MSG } from '../dialog';
import getStoreLan from './languages';
import {
  storeLocation,
  storePayTypeList,
  storeProductList,
  setDefaultPayType,
  storeServerId,
  storeServerName,
  storeRoleName,
  storeCoinName,
  getStoreHrefParam,
  storeCurLocation,
  storeUserInfo,
  storeIsSdk
} from './storager';
import globalConfig from '../../utiles/globalConfig';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
import { errorReport, ERROR_TYPE } from '@utiles/errorReport';
import { updateCommonParamsInfo } from '@plugins/biPoint/commonParam';
const mainHost = globalConfig.getMainHost();
export const LOAD_INIT_DATA = 'loadStoreInitData';
export const RELOAD_WAY_BY_LOCA = 'reloadPayWayByLocation';
export const SET_PAY_TYPES = 'setPayType';
export const POST_ORDER = 'postOrder';
export const GET_LOGIN_STATUS = 'getLoginStatus';
export const GO_LOGOUT = 'go_logout';
const LOGOUT_ACTION = `https://gpassport.${mainHost}/web_login/logout`;
const LOAD_JS = 'loadJs';
const INIT_ACTION = 'init_data';
const RELOAD_WAY_ACTION = 'get_piece_list';
const SET_INIT_DATA = 'setStoreInitData';
const SET_USER_INFO = 'setUserInfo';
const SET_LOADING_STATE = 'setLodingState';
const getLoginStatusUrl = `//gpassport.${mainHost}/center/ajax/get_store_user_json`;
let formatLocation = function (allLocation) {
  let locations = [];
  // eslint-disable-next-line no-unused-vars
  for (let value in allLocation) {
    let name = allLocation[value];
    let locationObj = {
      name,
      value
    };
    locations.push(locationObj);
  }
  return locations;
};
// 从链接获取language 语言，并且对文案进行初始化。
languages.init();
// twStore
Api.activeCache();
export const STORAGE_KEY = 'gmstore-vuejs'; // 本地缓存系统标识
export const config = {
  // 储值平台包含的地区文案映射列表
  regions: {
    TW: '台灣',
    HK: '香港',
    MY: '馬來西亞',
    SG: '新加坡',
    GLOBAL: '其他'
  }
};
const store = {
  state: {
    showStoreTips: '',
    locations: [],
    curLocation: '',
    coin_name: '',
    max_extra_ratio: '',
    languages: getStoreLan(),
    isLoadingPriceList: false,
    // twStore
    userInfo: {},
    config: {
      // 储存渠道数据，新增渠道都需要在这里添加相关信息
      channels: {
        virtual_account: {
          // 子渠道作为标识
          name: '銀行匯款', // 页面上显示的渠道文案
          link: '/pay/bank?id=virtual_account', // 子渠道作为id
          logo: 'c-chnl_bank',
          idMark: false // 该字段是个废弃字段（全局搜索后没有引用该字段的地方），同时也应该是isMark，后续维护忽略该字段
        },
        mycard_ingame_tw: {
          name: '台灣點卡',
          link: '/pay/mcds?id=mycard_ingame_tw',
          logo: 'c-chnl_mc-ds',
          idMark: false
        },
        mycard_ingame_os: {
          name: '海外點卡',
          link: '/pay/mcds?id=mycard_ingame_os',
          logo: 'c-chnl_mc-ds',
          idMark: false
        },
        mycard_webatm: {
          name: 'Web-ATM',
          link: '/pay/atm?id=mycard_webatm',
          logo: 'c-chnl_atm',
          idMark: false
        },
        mycard_telephone: {
          name: '手機/市話/寬頻',
          link: '/pay/call?id=mycard_telephone',
          logo: 'c-chnl_call',
          idMark: false
        },
        mycard_zfb: {
          name: '支付寶',
          link: '/pay/zfb?id=mycard_zfb',
          logo: 'c-chnl_zfb',
          idMark: false
        },
        paypal: {
          name: 'PayPal',
          link: '/pay/pp?id=paypal',
          logo: 'c-chnl_pp',
          idMark: false
        },
        gash: {
          name: 'Gash',
          link: '/pay/gash?id=gash',
          logo: 'c-chnl_gash',
          idMark: false
        },
        mycard_member_pay: {
          name: '會員扣點',
          link: '/pay/mchy?id=mycard_member_pay',
          logo: 'c-chnl_mc-hy',
          idMark: false
        },
        mycard_bdt: {
          name: '八達通',
          link: '/pay/bdt?id=mycard_bdt',
          logo: 'c-chnl_bdt',
          idMark: false
        },
        mycard_jfl: {
          name: 'PPS繳費靈',
          link: '/pay/jfl?id=mycard_jfl',
          logo: 'c-chnl_jfl',
          idMark: false
        },
        mol_point: {
          name: 'Razer Pin',
          link: '/pay/mozc?id=mol_point',
          logo: 'o-chnl-icon_mol-razer-pin',
          idMark: false
        },
        mol_wallet: {
          name: 'Razer Gold',
          link: '/pay/mozd?id=mol_wallet',
          logo: 'o-chnl-icon_mol-razer-gold',
          idMark: false
        },
        mycard_credit_card: {
          name: '信用卡(3D驗證)',
          link: '/pay/xyk?id=mycard_credit_card',
          logo: 'c-chnl_xyk',
          idMark: false
        },
        mycard_zgxtds: {
          name: '台灣信用卡',
          link: '/pay/xyk?id=mycard_zgxtds',
          logo: 'c-chnl_xyk',
          idMark: false,
          other: ['mycard_billing', 'TWD']
        },
        cosmopay_visa: {
          name: 'Visa',
          link: '/pay/ct?fid=cosmopay&id=cosmopay_visa',
          logo: 'c-chnl_Visa',
          slogo: 'Visa',
          idMark: false
        },
        cosmopay_master: {
          name: 'Master',
          link: '/pay/ct?fid=cosmopay&id=cosmopay_master',
          logo: 'c-chnl_Master',
          slogo: 'Master',
          idMark: false
        },
        'VISA-SSL': {
          name: 'Visa',
          link: '/pay/ct?fid=world_pay&id=VISA-SSL',
          logo: 'c-chnl_Visa',
          slogo: 'Visa',
          idMark: false
        },
        'ECMC-SSL': {
          name: 'Master',
          link: '/pay/ct?fid=world_pay&id=ECMC-SSL',
          logo: 'c-chnl_Master',
          slogo: 'Master',
          idMark: false
        },
        'paydibs-MYR': {
          name: 'Paydibs',
          link: '/pay/ct?fid=cosmopay&id=paydibs-MYR',
          logo: 'c-chnl_paydibs', // 主页大logo
          slogo: 'paydibs', // 内页小logo
          idMark: false
        },
        'paydibs-SGD': {
          name: 'Paydibs',
          link: '/pay/ct?fid=cosmopay&id=paydibs-SGD',
          logo: 'c-chnl_paydibs', // 主页大logo
          slogo: 'paydibs', // 内页小logo
          idMark: false
        },
        maxis: {
          name: 'maxis',
          link: '/pay/ct?fid=maxis&id=maxis',
          logo: 'c-chnl_maxis', // 主页大logo
          slogo: 'maxis', // 内页小logo
          idMark: false
        },
        mol_fpx: {
          name: 'Bank(FPX)',
          link: '/pay/ct?fid=mol&id=mol_fpx',
          logo: 'c-chnl_fpx', // 主页大logo
          slogo: 'fpx', // 内页小logo
          idMark: false
        },
        mol_enets: {
          // 该渠道使用fpx渠道的图标
          name: 'eNETS',
          link: '/pay/ct?fid=mol&id=mol_enets',
          logo: 'c-chnl_fpx', // 主页大logo
          slogo: 'fpx' // 内页小logo
        }
      },

      // 数据统计所需配置信息
      statistics: {
        // plat:parseInt(SDK.isSdk) ? 2 : 1, // 当前环境：浏览器 or SDK
        os: Api.getMobileOS() == 'iOS' ? 1 : 2,
        timestamp: new Date().getTime(),
        step1: false,
        step2: false,
        step3: false,
        step4: false,
        step5: false,
        step5active: new Date().getTime(),
        step6: false
      }
    },
    back: '',
    channelId: null, // 当前渠道id
    dialog: {
      // 弹窗数据
      isActive: false, // 遮罩是否激活
      isLoaded: true, // 列表数据是否加载完毕
      id: '', // 弹窗类型id
      prevId: '', // 前一个弹窗类型id
      length: 0, // 选择列表的长度
      account: '請獲取銀行虛擬帳號', // 银行汇款获取的虚拟账号
      ctrl: {
        // 选择弹窗控件对应的文本
        game: {
          id: 161,
          txt: '日理萬姬',
          // len:GAMES.length
          len: 1
        },
        sfq: {
          id: 0,
          sid: 0,
          txt: '請選擇伺服器',
          len: 0
        },
        role: {
          id: 0,
          txt: '請選擇角色',
          // len:ROLES.length
          len: 0
        },

        // 选择的地区信息
        //   region:{
        //     id:SDK.cur_location,
        //     txt:config.regions[SDK.cur_location],
        //     len:CUR_LOCATION.length
        //   },
        region: {
          id: 'SDK.cur_location',
          txt: 'config.regions[SDK.cur_location]',
          len: 0
        },
        // 选择的产品数据
        product: {
          id: '',
          txt: '',
          tip: '',
          remark: ''
        },

        // 选择的银行/运营商列表
        bank: {
          pay: '',
          fpay: '',
          currency: '',
          txt: ''
        }
      },

      // 列表数据
      lists: {
        games: [{ name: '日理萬姬', id: 161 }], // 游戏
        sfqs: [], // 伺服器
        roles: [], // 角色
        // regions:CUR_LOCATION, // 地区
        regions: '台灣',
        products: [], // 闪商品
        banks: [], // 银行
        operators: [] // 运营商
      },

      // 存储mycard点数卡渠道的订单提交状态&信息
      mcds: {
        hasPay: false,
        postFields: {} // 表单提交所需数据
      },

      // channeltpl.vue组件对应的支付方式
      ctpay: {
        formCommit: false,
        redirectUrl: '',
        postFields: null
      }
    },

    // 提示信息弹窗数据
    tip: {
      isActive: false, // 弹窗是否激活
      txt: '', // 提示语
      call: null // 信息弹窗关闭之后的回调
    },
    channels: [], // 渠道列表
    pays: {
      // 支付信息
      bank: {
        id: '',
        gameName: '',
        sfqName: '',
        roleName: '',
        amount: '', // 储值金额
        pay: '', // 子渠道
        fpay: '', // 父渠道
        currency: ''
      }
    },
    /**
     * 验证规则策略库
     * @type {Object}
     */
    strategies: {
      /**
       * 非空验证规则
       * @param  {String}  val    [用户的输入值]
       * @param  {String}  errMsg [验证失败的返回值]
       * @return {String/Undefined}        [验证成功返回undefined，验证失败返回errMsg]
       */
      isNonEmpty: function (val) {
        let flag = true;
        if (val === '' || val == 0) flag = false;
        return flag;
      },
      isNumber: function (val) {
        let flag = true;
        if (!/^\d+$/.test(val)) flag = false;
        return flag;
      }
    }
  },
  getters: {
    isLoadingPriceList: state => {
      return state.isLoadingPriceList;
    }
  },
  mutations: {
    [SET_INIT_DATA](state, data) {
      state.config = data;
      state.locations = formatLocation(data.all_locations);
      state.curLocation = data.current_location;
      state.coin_name = data.coin_name;
      state.max_extra_ratio = data.max_extra_ratio;
      // 1月23号0点-1月29号22点期间显示储值提示弹窗(需求方-吴温迪)
      state.showStoreTips =
        data.timestamp >= 1579708800 && data.timestamp <= 1580306400;
      storeCurLocation(data.current_location);
      storeLocation(state.locations);
      storePayTypeList(data.paytype_list);
      storeProductList(data.product_list);
      setDefaultPayType(data.paytype_list[0]);
      storeServerId(data.server_id);
      storeServerName(data.server_name);
      storeRoleName(data.role_name);
      storeCoinName(data.coin_name);
      storeIsSdk(data.is_sdk);
    },
    [SET_PAY_TYPES](state, payType) {
      state.curPayType = payType;
    },
    // twStore
    [SET_USER_INFO](state, userInfo) {
      state.userInfo = userInfo;
      storeUserInfo(userInfo);
    },
    [SET_LOADING_STATE](state, tag) {
      state.isLoadingPriceList = tag;
    },
    /**
     * 显示对话框
     * @param  {[type]} state [description]
     * @param  {Strign} id    [被显示对话框id]
     * @return {[type]}       [description]
     */
    showDialogTw(state, id) {
      state.dialog.id = id;
      state.dialog.isActive = true;
      this.commit('preventScroll');
    },
    setPayTypes(state, payType) {
      state.curPayType = payType;
    },
    setPayBankInfo(state, payBankInfo) {
      state.pays.bank = payBankInfo;
    },
    /**
     * 隐藏对话框
     * @param  {[type]} state [description]
     * @param  {Strign} id    [被隐藏对话框id]
     * @return {[type]}       [description]
     */
    hideDialog(state, id) {
      this.commit('resetScroll');
      state.dialog.id = '';
      state.dialog.prevId = id;
      state.dialog.isActive = false;
    },

    /**
     * 禁止弹窗以下内容滚动
     * @return {[type]} [description]
     */
    preventScroll() {
      let scrollTop = document.body.scrollTop;
      let bodyEl = document.getElementsByTagName('body')[0];
      bodyEl.classList.add('modal-open');
      bodyEl.style.top = -scrollTop + 'px';
    },

    /**
     * 取消滚动禁止
     * @return {[type]} [description]
     */
    resetScroll() {
      let bodyEl = document.getElementsByTagName('body')[0];
      let scrollTop = Math.abs(parseInt(bodyEl.style.top));
      bodyEl.classList.remove('modal-open');
      document.body.scrollTop = scrollTop;
    },

    /**
     * 显示提示信息
     * @param  {[type]} state [description]
     * @param  {Object} tip   [.txt：提示信息, .call：回调函数]
     * @return {[type]}       [description]
     */
    showTip(state, tip) {
      state.tip.isActive = true;
      if (Object.prototype.toString.call(tip).indexOf('Object') != -1) {
        state.tip.txt = tip.txt;
        typeof tip.call == 'function' && (state.tip.call = tip.call);
      } else {
        state.tip.txt = tip;
      }
    },

    /**
     * 列表弹窗的选择功能
     * @param  {[type]} state [description]
     * @param  {[Obj]} sel   [.txt：选择项id, .ctrlId：弹窗列表id, .txt：选择项文本, .remark：透传道具ID]
     * @return {[type]}       [description]
     */
    doSelect(state, sel) {
      let selId = sel.id;
      let ctrlId = sel.ctrlId;
      let tip = sel.tip || '';
      let txt = sel.txt;
      let remark = sel.remark;
      state.dialog.ctrl[ctrlId].id = selId;
      state.dialog.ctrl[ctrlId].sid = sel.sid;
      state.dialog.ctrl[ctrlId].tip = tip;
      state.dialog.ctrl[ctrlId].txt = txt;
      state.dialog.ctrl[ctrlId].remark = remark;
    },
    changeDialogId(state, id) {
      state.dialog.id = id;
    },
    changeDialogLoaded(state, isLoaded) {
      state.dialog.isLoaded = isLoaded;
    },
    changeDialogSfqLen(state, len) {
      state.dialog.ctrl.sfq.len = len;
    },
    changeDialogRolesLen(state, len) {
      state.dialog.ctrl.role.len = len;
    },
    changeDialoglistsSfq(state, sfqs) {
      state.dialog.lists.sfqs = sfqs;
    },
    changeDialoglistsRole(state, roles) {
      state.dialog.lists.roles = roles;
    },
    resetDialogSfq(state, data) {
      let sfq = state.dialog.ctrl.sfq;
      sfq.id = 0;
      sfq.sid = 0;
      sfq.txt = '請選擇伺服器';
      sfq.len = 0;
      state.dialog.lists.sfqs.length = 0; // 清空伺服器
    },
    resetTips(state) {
      state.tip.isActive = false;
      state.tip.txt = '';
    },
    resetDialogRole(state, data) {
      let role = state.dialog.ctrl.role;
      role.id = 0;
      role.txt = '請選擇角色';
      role.len = 0;
      state.dialog.lists.roles.length = 0; // 清空角色列表
    },
    setAccount(state, account) {
      state.dialog.account = account || '請獲取銀行虛擬帳號';
    },
    /**
     * 银行/运营商等列表弹窗选择功能
     * @param  {[type]} state [description]
     * @param  {[Obj]} sel   [.pay：子渠道, .fpay：父渠道, .txt：选择项文本, ?.currency：渠道币种]
     * @return {[type]}       [description]
     */
    doSelBank(state, sel) {
      state.dialog.ctrl.bank.pay = sel.pay;
      state.dialog.ctrl.bank.fpay = sel.fpay;
      state.dialog.ctrl.bank.txt = sel.txt;
      state.dialog.ctrl.bank.currency = sel?.currency;
    },

    /*  doSelMoney (state,sel) {
        let ctrlId = sel.ctrlId,
            num    = sel.num;
        state.dialog.ctrl[ctrlId]?.amount = num;
      }, */

    /**
     * 设置游戏列表
     * @param {[type]} state [description]
     * @param {[Array]} datas [游戏列表]
     */
    setGameList(state, datas) {
      state.dialog.ctrl.list.games = datas;
    },

    /**
     * 获取渠道列表数据
     * @param  {[type]} state  [description]
     * @param  {[Obj]} params [.data：接口所需参数, .key：本地缓存的key, .item：本地缓存二层key]
     * @return {[type]}        [description]
     */
    doGetChannels(state, params) {
      let param = {
        url: '//mstore.gm99.com/show_paytype',
        type: 'get',
        dataType: 'jsonp',
        data: params.data
      };
      if (params.key) {
        param.localKey = params.key;
      }
      if (params.item) {
        param.localItem = params.item;
      }
      Api.ajax(param).then(
        function (res) {
          Api.log(res);
          res.isAjax && Api.cacheMode(params.key, res.data);
        },
        function (res) {
          Api.log(res);
        }
      );
    },

    /**
     * [序列化渠道列表信息]
     * @param  {[type]} state [description]
     * @param  {[Array]} datas [渠道列表数据]
     * @return {[type]}       [description]
     */
    serialChannel(state, datas) {
      let channels = [];
      for (let i = 0, l = datas.length; i < l; i++) {
        let temp = datas[i];
        let item = {
          id: temp[1]
        };
        item.other = [temp[0], temp[2]];
        item.info = state.config.channels[item.id];
        item.extra = temp[3] ? temp[3] : 0;
        if (state.config.channels[item.id]) {
          state.config.channels[item.id].other = item.other; // 存储父渠道等信息
          channels.push(item);
        }
      }
      state.channels = channels;
    },

    /**
     * 获取渠道商品数据
     * @param  {[type]} state [description]
     * @return {[type]}       [description]
     */
    getProduct(state) {
      let pay = state.channelId;
      let channelInfo = state.config.channels[pay];
      if (!channelInfo) return;
      let fpay = channelInfo.other ? channelInfo.other[0] : '';
      let currency = channelInfo.other ? channelInfo.other[1] : '';

      let params = {
        fpaytype: fpay,
        paytype: pay,
        currency: currency
      };

      let succ = function (res) {
        state.dialog.lists.products = res.data;
        res.isAjax && Api.cacheMode(res.key, res.data);
      };

      // eslint-disable-next-line no-undef
      twStore.mutations.doGetProduct(state, {
        data: params,
        succ: succ
      });
    },

    /**
     * 请求渠道商品获取接口
     * @param  {[type]} state  [description]
     * @param  {[Onj]} params [description]
     * @return {[type]}        [description]
     */
    doGetProduct(state, params) {
      let gameId = state.dialog.ctrl.game.id;
      let sfqId = state.dialog.ctrl.sfq.id;
      let roleId = state.dialog.ctrl.role.id;
      let region = state.dialog.ctrl.region.id;
      let key =
        'PRODUCT_' +
        gameId +
        '_' +
        roleId +
        '_' +
        region +
        '_' +
        params.data?.paytype;
      let datas = {
        localKey: key,
        url: '//mstore.gm99.com/show_product',
        type: 'get',
        dataType: 'jsonp',
        data: {
          game_id: gameId,
          server_id: sfqId,
          role_id: roleId,
          fpaytype: params.data.fpaytype,
          paytype: params.data?.paytype,
          currency: params.data?.currency
        }
      };
      Api.ajax(datas).then(
        function (res) {
          Api.log(res);
          res.key = key;
          typeof params.succ == 'function' && params.succ(res);
        },
        function (res) {
          Api.log(res);
          typeof params.fail == 'function' && params.fail(res);
        }
      );
    },

    // 获取银行列表信息
    doGetBank(state, params) {
      Api.ajax({
        url: '//mstore.gm99.com/mycard_billing/show_mycard_billing_catalog',
        type: 'get',
        dataType: 'jsonp',
        data: {
          catalog: params.type
        }
      }).then(
        function (res) {
          Api.log(res);
          typeof params.succ == 'function' && params.succ(res);
        },
        function (res) {
          Api.log(res);
          typeof params.fail == 'function' && params.fail(res);
        }
      );
    },

    // 提交支付订单：部分渠道会用该api提交，参考dialog.vue
    doPay(state, params) {
      let ctrl = state.dialog.ctrl;
      let gameId = ctrl.game.id;
      let sfqId = ctrl.sfq.id;
      let roleId = ctrl.role.id;
      let roleName = ctrl.role.txt;
      let productId = ctrl.product.id;
      let remark = ctrl.product.remark;

      Api.ajax({
        url: '//mstore.gm99.com/' + params.fpay + '/submit',
        type: 'post', // 非跨越下改回post
        dataType: 'jsonp',
        data: {
          gameId: gameId,
          serverId: sfqId,
          roleId: roleId,
          roleName: roleName,
          productId: productId,
          paytype: params.data?.paytype,
          fpaytype: params.fpay,
          currency: params.data?.currency,
          remark: remark
        }
      }).then(
        function (res) {
          Api.log(res);
          state.config.statistics.step6 = true;
          if (params && typeof params.succ == 'function') {
            params.succ(res);
          } else {
            window.open(res.data.redirect_url, '_self');
          }
        },
        function (res) {
          Api.log(res);
          let tip = null;
          if (params && typeof params.fail == 'function') {
            tip = {
              txt: res?.msg,
              call: params.fail.bind(this, res)
            };
          } else {
            tip = res?.msg;
          }
          if (state.dialog.isActive) {
            // eslint-disable-next-line no-undef
            twStore.mutations.hideDialog(state, state.dialog.id);
          }
          // eslint-disable-next-line no-undef
          twStore.mutations.showTip(state, tip);
        }
      );
    },

    // 默认使用该api提交支付订单
    doDefaultPay(state, params) {
      let ctrl = state.dialog.ctrl;
      let pay = state.channelId;
      let channelInfo = state.config.channels[pay];
      let fpay = channelInfo.other[0];
      // gameId = ctrl.game.id,
      // sfqId = ctrl.sfq.id,
      // roleId = ctrl.role.id,
      // roleName = ctrl.role.txt,
      // productId = ctrl.product.id,
      // pay = state.channelId,

      // currency = channelInfo.other[1];
      var param = {
        gameId: ctrl.game.id,
        serverId: ctrl.sfq.id,
        roleId: ctrl.role.id,
        roleName: ctrl.role.txt,
        productId: ctrl.product.id,
        paytype: pay,
        fpaytype: fpay,
        currency: channelInfo.other[1],
        remark: ctrl.product.remark
      };
      // maxis  渠道 的电话号码
      if (state.pays.bank && state.pays.bank.msisdn) {
        param.msisdn = state.pays.bank.msisdn;
      }
      Api.ajax({
        url: '//mstore.gm99.com/' + fpay + '/submit',
        type: 'post', // 非跨越下改回post
        dataType: 'jsonp',
        data: param
      }).then(
        function (res) {
          Api.log(res);
          state.config.statistics.step6 = true;
          if (params && typeof params.succ == 'function') {
            params.succ(res);
          } else {
            window.location.href = res.data.redirect_url;
          }
        },
        function (res) {
          Api.log(res);
          let tip = null;
          if (params && typeof params.fail == 'function') {
            tip = {
              txt: res?.msg,
              call: params.fail.bind(this, res)
            };
          } else {
            tip = res?.msg;
          }
          if (state.dialog.isActive) {
            // eslint-disable-next-line no-undef
            twStore.mutations.hideDialog(state, state.dialog.id);
          }
          // eslint-disable-next-line no-undef
          twStore.mutations.showTip(state, tip);
        }
      );
    },

    // 执行表单验证
    _doVerify(forms) {
      let ret = { flag: true };
      for (let i = 0, l = forms.length; i < l; i++) {
        // eslint-disable-next-line no-undef
        let res = twStore.mutations._verifyRule(forms[i].val, forms[i].rules);
        if (!res.flag) {
          typeof forms[i].call == 'function' && forms[i].call(res);
          ret = res;
          break;
        }
      }
      return ret;
    },

    // 根据规则进行验证
    _verifyRule(val, rules) {
      for (let i = 0, l = rules.length; i < l; i++) {
        let rule = null;
        let msg = null;
        if (typeof rules[i] == 'string') {
          rule = rules[i];
        } else {
          rule = rules[i].rule;
          msg = rules[i].errMsg;
        }
        // eslint-disable-next-line no-undef
        let run = state.strategies[rule](val);
        if (!run) return { flag: false, msg: msg };
      }

      return { flag: true };
    }
  },
  actions: {
    [LOAD_INIT_DATA]({ commit, dispatch }) {
      let params = getStoreHrefParam() || {};
      params['gameId'] = 161;
      params['timeStamp'] = '1234';
      return new Promise(resolve => {
        getJSON(STORE_HOST + INIT_ACTION, params).then(({ errmsg, data }) => {
          if (!data.paytype_list?.length) {
            errorReport(ERROR_TYPE.PAY_TYPE_LIST_EMPTY);
          }
          if (!errmsg) {
            commit(SET_USER_INFO, {
              userId: data.user_id,
              userName: data.login_account
            });
            commit(SET_INIT_DATA, data);
            if (data.scripts && data.scripts.fingerprint_url) {
              dispatch(LOAD_JS, data.scripts.fingerprint_url);
            }
            resolve(data);
          } else {
            resolve(false);
          }
        });
      });
    },
    [GET_LOGIN_STATUS]({ commit, dispatch }, params = {}) {
      return new Promise((resolve, reject) => {
        getJSON(getLoginStatusUrl, params).then(({ errmsg, data }) => {
          if (!errmsg) {
            commit(SET_USER_INFO, {
              userId: data.ID,
              userName: data.LOGIN_ACCOUNT
            });
            updateCommonParamsInfo({
              loginAccount: data.LOGIN_ACCOUNT,
              uid: data.UID
            });
            window.webstorev0DataLayer.push({
              eventName: 'login',
              eventType: data?.LOGIN_PATH || ''
            });
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
    // 登出
    [GO_LOGOUT]({ commit, state }) {
      return new Promise(resolve => {
        getJSON(LOGOUT_ACTION, {
          language: state.lang
        }).then(({ errmsg, res }) => {
          updateCommonParamsInfo({
            loginAccount: '',
            uid: '',
            serverId: '',
            roleName: '',
            roleId: ''
          });
          resolve({ result: parseInt(res.result, 10) === 1 });
        });
      });
    },
    [RELOAD_WAY_BY_LOCA]({ commit, state, dispatch }, locationVal) {
      return new Promise(resolve => {
        let param = {
          gameId: 161,
          serverId: state.dialog.ctrl.sfq.sid,
          roleId: state.dialog.ctrl.role.id
        };
        param['location'] = locationVal;
        commit(SET_LOADING_STATE, true);
        console.log(state.isLoadingPriceList);
        getJSON(STORE_HOST + RELOAD_WAY_ACTION, param).then(
          ({ errmsg, data }) => {
            if (!errmsg) {
              storePayTypeList(data.paytype_list);
              commit(SET_LOADING_STATE, false);
              console.log(state.isLoadingPriceList);
              // setDefaultPayType(data.paytype_list[0]); 默认第一次设置的，不需要重复设置
              resolve(true);
            } else {
              dispatch(SHOW_TIPS_MSG, {
                message: errmsg
              });
            }
          }
        );
      });
    },
    [POST_ORDER]({ commit, dispatch }, params) {
      return new Promise((resolve, reject) => {
        const ACTION = params?.f_pay_type + '/submit';
        post(STORE_HOST + ACTION, params).then(({ errmsg, res }) => {
          if (!errmsg) {
            resolve(res);
          } else {
            dispatch(SHOW_TIPS_MSG, {
              message: errmsg
            });
            reject();
          }
        });
      });
    },
    // 加载第三方js
    [LOAD_JS]({ commit, dispatch }, params) {
      return new Promise(resolve => {
        getJSON(params, {}).then(({ errmsg, res }) => {
          resolve();
        });
      });
    }
  }
};
export default {
  strict: process.env.NODE_ENV !== 'production', // 在非生产环境下，使用严格模式
  state: {
    cancel: languages.get('cancel'),
    confirm: languages.get('confirm')
  },
  modules: {
    account,
    dialog,
    passport,
    store,
    support,
    accountSetting,
    findPassword,
    services
  }
};
